import { getCore } from '../../../client/core/getCore';
import type { DynamicClient } from '../../../client/types';

type RegisterExtensionParams = {
  extensionKey: string;
};

/**
 * Registers an extension to the client.
 *
 * Other extensions can be aware of which extensions are present,
 * and allows creating dependencies between extensions.
 *
 * @param client - The client instance.
 * @param extensionKey - The key of the extension to register.
 * @returns The client instance.
 */
export const registerExtension = (
  { extensionKey }: RegisterExtensionParams,
  client: DynamicClient
) => {
  const core = getCore(client);

  core.extensions.add(extensionKey);
};
